import React from 'react'

import ActionsBox from '@/app/module/campaigns/component/actions/actions-box'
import { SMS_ACTION_DEFAULT_SENDERID } from '@/app/module/campaigns/definitions'
import { ChoiceValueSingle, LocalAction, LocalOnAnswerType } from '@/app/module/campaigns/types'
import { getActionOptionsForCampaign } from '@/app/module/campaigns/utils/actions/options'

import { ActionProps, ApiProps } from './part-config-props'
import SingleChoice from './question/choice/single-choice'

type Props = {
  actionOptions: ReturnType<typeof getActionOptionsForCampaign>
  actionProps: ActionProps
  actions: LocalAction[]
  apiProps: ApiProps
  choiceIndex: number
  id: string
  isCloseDisabled: boolean
  label?: string
  reply: string

  onChange: (value: LocalOnAnswerType, index: number) => void
  onRemove: (index: number) => void
}

const ResponseTextChoiceSingle: React.FC<Props> = ({
  actionOptions,
  actionProps,
  actions,
  apiProps,
  choiceIndex,
  id,
  isCloseDisabled,
  label,
  reply,
  onChange,
  onRemove,
}) => {
  const handleActionsChange = React.useCallback(
    (actionsList: LocalAction[]) => {
      onChange(
        {
          reply,
          actions: actionsList,
          label,
        },
        choiceIndex,
      )
    },
    [choiceIndex, label, reply, onChange],
  )

  const handleChoiceChange = React.useCallback(
    (value: ChoiceValueSingle) => {
      onChange(
        {
          reply: value.reply,
          actions,
          label,
        },
        choiceIndex,
      )
    },
    [actions, choiceIndex, label, onChange],
  )

  const handleLabelChange = React.useCallback(
    (newLabel: string) => {
      onChange(
        {
          reply,
          actions,
          label: newLabel,
        },
        choiceIndex,
      )
    },
    [actions, choiceIndex, reply, onChange],
  )

  const handleRemove = React.useCallback(() => onRemove(choiceIndex), [choiceIndex, onRemove])

  return (
    <ActionsBox
      key={`text-${choiceIndex}`}
      actionOptions={actionOptions}
      actions={actions}
      defaultSenderId={SMS_ACTION_DEFAULT_SENDERID.catiQuestion}
      hasTranscribe={false}
      imageId={`${id}-${choiceIndex}`}
      isCloseDisabled={isCloseDisabled}
      label={label}
      transcribeEnabled={false}
      updateContactConfig={{
        invalid: false,
        openResponse: false,
        question: true,
      }}
      voiceId={`${id}-${choiceIndex}`}
      onChange={handleActionsChange}
      onLabelChange={handleLabelChange}
      onClose={handleRemove}
      {...actionProps}
      {...apiProps}
    >
      <SingleChoice tagList={{ reply }} onChange={handleChoiceChange} />
    </ActionsBox>
  )
}

export default React.memo(ResponseTextChoiceSingle)
